import { BsArrowLeft } from 'react-icons/bs';
import { HiArrowNarrowLeft } from 'react-icons/hi';
import SnakeGame from 'src/components/SnakeGame';
import {
  AddCombo,
  AddItem,
  BackOffice,
  Category,
  Combo,
  Designation,
  EmployeeList,
  Floors,
  ForgetPassword,
  Help,
  ItemsList,
  KDS,
  Login,
  Modifiers,
  Otp,
  Receipt,
  Refund,
  Register,
  Settings,
  Tables,
} from 'src/pages';
import PinVerification from 'src/pages/auth/pin-verification';
import ResetPassword from 'src/pages/auth/reset-password';
import Inventory from 'src/pages/back-office/Inventory/Inventory';
import Billing from 'src/pages/billing';
import Business from 'src/pages/business';
import Customer from 'src/pages/customer';
import ViewCustomer from 'src/pages/customer/ViewCustomer';
import Expenses from 'src/pages/expenses';
import FeedBack from 'src/pages/feedback';
import ViewCategory from 'src/pages/items/category/ViewCategory';
import AddEditCategory from 'src/pages/items/category/crud/AddEditCategory';
import Discount from 'src/pages/items/discount';
import Labels from 'src/pages/items/labels';
import Orders from 'src/pages/orders';
import AdminPayment from 'src/pages/orders/MakePayment';
import AdminPaymentMultiple from 'src/pages/orders/MakePaymentMultiple';
import SingleOrder from 'src/pages/orders/singleOrder';
import ViewRefund from 'src/pages/receipt/components/viewRefund';
import DailySummary from 'src/pages/report/DailySummary';
import ItemSales from 'src/pages/report/ItemSales';
import Details from 'src/pages/restaurant/details';
import ClosedTickets from 'src/pages/sales/closed-tickets';
import DineIn from 'src/pages/sales/dine-in';
import OnlineOrder from 'src/pages/sales/online-order';
import OpenTickets from 'src/pages/sales/open-tickets';
import Payment from 'src/pages/sales/payment';
import Shift from 'src/pages/sales/shift';
import ShiftOpen from 'src/pages/sales/shift-open';
import Table from 'src/pages/sales/table';
import Variants from 'src/pages/sales/variants';
import SalesSummary from 'src/pages/salesSummary';
import CashReport from 'src/pages/shift/cash';
import ViewShift from 'src/pages/shift/shift/components/viewShift';

export const routesData = [
  {
    id: 0,
    path: '/settings',
    element: <Settings />,
    width: 'full',
    heading: 'Settings',
    adminOnly: true,
  },
  {
    id: 1,
    path: '/receipt',
    element: <Receipt />,
    width: 'full',
    heading: 'Receipt',
    title: 'Receipt',
    adminOnly: true,
    Lock: true,
  },
  {
    id: 2,
    path: '/designation',
    element: <Designation />,
    heading: 'Designation',
    title: 'Designation',
    adminOnly: true,
    // Lock: true,
  },
  {
    id: 3,
    path: '/employee-list',
    element: <EmployeeList />,
    heading: 'Employee',
    adminOnly: true,
    // Lock: true,
  },
  {
    id: 4,
    path: '/customers',
    element: <Customer />,
    heading: 'Customers',
    adminOnly: true,
  },
  {
    id: 5,
    path: '/customer-detail/:customerId',
    element: <ViewCustomer />,
    width: 'full',
    heading: 'View Customer',
    icon: <HiArrowNarrowLeft size={20} />,
    adminOnly: true,
  },
  {
    id: 6,
    path: '/',
    element: <BackOffice />,
    width: 'full',
    heading: 'Dashboard',
    adminOnly: true,
    // Lock: true,
  },
  {
    id: 7,
    path: '/receipt-refund/:id',
    element: <Refund />,
    heading: 'Refund',
    adminOnly: true,
  },
  {
    id: 8,
    path: '/restaurant-floors',
    element: <Floors />,
    heading: 'Areas',
    adminOnly: true,
    // Lock: true,
  },
  {
    id: 9,
    path: '/restaurant-tables',
    element: <Tables />,
    heading: 'Table Management',
    adminOnly: true,
    // Lock: true,
  },
  {
    id: 10,
    path: '/help',
    element: <Help />,
    width: 'full',
    heading: 'Help',
    adminOnly: true,
  },
  {
    id: 11,
    path: '/item-categories',
    element: <Category />,
    heading: 'Category',
    adminOnly: true,
  },
  {
    id: 12,
    path: '/item-modifiers',
    element: <Modifiers />,
    heading: 'Modifiers',
    adminOnly: true,
  },
  {
    id: 13,
    path: '/item-combo',
    element: <Combo />,

    adminOnly: true,
  },
  {
    id: 14,
    path: '/item-add-combo',
    element: <AddCombo />,
    adminOnly: true,
  },
  {
    id: 15,
    path: '/add-item',
    element: <AddItem />,
    width: 'full',
    icon: <HiArrowNarrowLeft size={20} />,
    heading: 'Add Item',
    adminOnly: true,
  },
  {
    id: 16,
    path: '/items-list',
    element: <ItemsList />,
    width: 'full',
    heading: 'Items',
    adminOnly: true,
  },
  {
    id: 17,
    path: '/items-label',
    element: <Labels />,
    adminOnly: true,

    heading: 'Label',
  },
  {
    id: 18,
    path: '/item-discount',
    element: <Discount />,
    heading: 'Discount',
    adminOnly: true,
  },
  {
    id: 19,
    path: '/cash/:id',
    element: <CashReport />,
    title: 'Shift Reports',
    heading: 'Cash Drawer',
    icon: <BsArrowLeft size={24} />,
    adminOnly: true,
  },
  // {
  //   id: 20,
  //   path: '/shift',
  //   element: <ShiftReport />,
  //   width: 'full',
  //   heading: 'Shifts',
  //   title: 'Shift Reports',
  //   adminOnly: true,
  //   Lock: true,
  // },
  {
    id: 101,
    path: '/game',
    element: <SnakeGame />,
    adminOnly: true,
  },
  {
    id: 21,
    path: '/dine-in',
    element: <DineIn />,
    title: (
      <div className="flex gap-4">
        <div className="flex flex-row items-center cursor-pointer text-black">
          <svg
            stroke="currentColor"
            fill="currentColor"
            stroke-width="0"
            viewBox="0 0 16 16"
            font-size="20"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
            ></path>
          </svg>
        </div>
        <div className="border w-[135px] cursor-pointer h-[33px] rounded-xl   flex gap-[6px] items-center justify-center font-Outfit font-semibold  text-sm hover:text-[#4062FF] hover:border-[#4062FF] border-[#4062FF] text-[#4062FF]">
          Online Order
        </div>
      </div>
    ),
    adminOnly: false,
  },
  {
    id: 22,
    path: '/table',
    element: <Table />,
    adminOnly: false,
  },
  {
    id: 23,
    path: '/table/variants',
    element: <Variants />,
    adminOnly: false,
  },
  {
    id: 24,
    path: '/shift-open',
    element: <ShiftOpen />,
    // Lock: true,
    adminOnly: false,
  },
  {
    id: 25,
    path: '/payment',
    element: <Payment />,
    adminOnly: false,
  },
  {
    id: 251,
    path: '/payment/admin',
    element: <AdminPayment />,
    adminOnly: true,
  },
  {
    id: '251-b',
    path: '/payment/admin/tables',
    element: <AdminPayment />,
    adminOnly: false,
  },
  {
    id: 'payment-admin-multiple',
    path: '/payment/admin/multiple',
    element: <AdminPaymentMultiple />,
    adminOnly: true,
  },
  {
    id: 26,
    path: '/open-tickets',
    element: <OpenTickets />,
    heading: 'Open tickets',
    icon: <BsArrowLeft size={24} />,
    adminOnly: false,
  },
  {
    id: 'closed-tickets',
    path: '/closed-tickets',
    element: <ClosedTickets />,
    heading: 'Closed tickets',
    icon: <BsArrowLeft size={24} />,
    adminOnly: false,
  },
  {
    id: 27,
    path: '/shift-detail/:id',
    element: <ViewShift />,
    width: 'full',
    heading: 'Shift Report',
    icon: <BsArrowLeft size={24} />,
    adminOnly: true,
  },
  {
    id: 28,
    path: '/restaurant-detail',
    heading: 'Restaurant',
    element: <Details />,
    width: 'full',
    adminOnly: true,
  },
  {
    id: 29,
    path: '/feedbacks',
    element: <FeedBack />,
    width: 'full',
    heading: 'Feedbacks',
    adminOnly: true,
  },
  {
    id: 30,
    path: '/edit-item',
    element: <AddItem />,
    width: 'full',
    heading: 'Edit Item',
    adminOnly: true,
  },
  {
    id: 31,
    path: '/orders',
    element: <Orders />,
    width: 'full',
    heading: 'Orders',
    adminOnly: true,
  },
  {
    id: 32,
    path: '/orders/:id',
    adminOnly: true,
    element: <SingleOrder />,
    width: 'full',
    heading: 'SingleOrder',
    icon: <HiArrowNarrowLeft size={20} />,
  },
  {
    id: 33,
    path: '/shift-detail/:id',
    element: <ViewShift />,
    width: 'full',
    heading: 'Shift Report',
    icon: <BsArrowLeft size={24} />,
    adminOnly: true,
  },
  {
    id: 34,
    path: '/restaurant-detail',
    element: <Details />,
    width: 'full',
    adminOnly: true,
  },
  {
    id: 35,
    path: '/feedbacks',
    element: <FeedBack />,
    width: 'full',
    heading: 'FeedBack',
    adminOnly: true,
  },
  {
    id: 36,
    path: '/edit-item',
    element: <AddItem />,
    width: 'full',
    heading: 'Edit Item',
    adminOnly: true,
  },
  {
    id: 37,
    path: '/orders',
    element: <Orders />,
    width: 'full',
    heading: 'Orders',
    adminOnly: true,
  },
  {
    id: 38,
    path: '/orders/:id',
    element: <SingleOrder />,
    width: 'full',
    heading: 'SingleOrder',
    icon: <HiArrowNarrowLeft size={20} />,
    adminOnly: true,
  },
  {
    id: 39,
    path: '/view-refund',
    element: <ViewRefund />,
    width: 'full',
    icon: <HiArrowNarrowLeft size={20} />,
    heading: 'Refunded',
    adminOnly: true,
  },
  {
    id: 40,
    path: '/current-shift-details',
    element: <Shift />,
    adminOnly: false,
  },
  {
    id: 41,
    path: '/online-order',
    element: <OnlineOrder />,
    width: 'full',
    adminOnly: false,
  },
  {
    id: 7,
    path: '/restaurant-floors',
    element: <Floors />,
    heading: 'Areas',
    Lock: true,
  },
  {
    id: 8,
    path: '/restaurant-tables',
    element: <Tables />,
    heading: 'Table Management',
    Lock: true,
  },
  {
    id: 42,
    path: '/category-detail/:categoryId',
    element: <ViewCategory />,
    width: 'full',
    heading: '[VIEW_CATEGORY]',
    icon: <HiArrowNarrowLeft size={20} />,
    adminOnly: true,
  },

  {
    id: 43,
    path: '/edit-category',
    element: <AddEditCategory />,
    heading: 'Edit Category',
    icon: <HiArrowNarrowLeft size={20} />,
    adminOnly: true,
  },
  {
    id: 5,
    path: '/business',
    element: <Business />,
    heading: 'Business',
    icon: <HiArrowNarrowLeft size={20} />,
    adminOnly: true,
  },
  {
    id: 5,
    path: '/kitchen-display',
    element: <KDS />,
    heading: 'Kitchen Display',
    icon: <HiArrowNarrowLeft size={20} />,
    adminOnly: true,
  },
  {
    id: 51,
    path: '/kitchen-display-sales',
    element: <KDS />,
    heading: 'Kitchen Display',
    icon: <HiArrowNarrowLeft size={20} />,
    adminOnly: false,
  },
  {
    id: 52,
    width: 'full',
    path: '/sales-summary',
    element: <SalesSummary />,
    heading: 'Sales Summary',
    icon: <HiArrowNarrowLeft size={20} />,
    adminOnly: true,
  },
  {
    id: 53,
    width: 'full',
    path: '/item-sales',
    element: <ItemSales />,
    heading: 'Item Sales',
    icon: <HiArrowNarrowLeft size={20} />,
    adminOnly: true,
  },
  {
    id: 52,
    width: 'full',
    path: '/daily-summary',
    element: <DailySummary />,
    heading: 'Sales Summary',
    icon: <HiArrowNarrowLeft size={20} />,
    adminOnly: true,
  },
  {
    id: 'inventory',
    path: '/inventory',
    element: <Inventory />,
    heading: 'Inventory',
    adminOnly: true,
  },
  {
    id: 'expenses',
    path: '/expenses',
    element: <Expenses />,
    heading: 'Expenses',
    adminOnly: true,
  },
  {
    id: 'billing',
    path: '/billing',
    element: <Billing />,
    heading: 'Billing',
    adminOnly: true,
  },
];

export const authRoutesData = [
  {
    id: 0,

    path: '/login',
    element: <Login />,
  },
  {
    id: 1,

    path: '/register',
    element: <Register />,
  },
  {
    id: 2,

    path: '/forget-password',
    element: <ForgetPassword />,
  },
  {
    id: 3,

    path: '/reset-password',
    element: <ResetPassword />,
  },
  {
    id: 3,
    path: '/otp',
    element: <Otp />,
  },
  {
    id: 4,
    path: '/pin-code',
    element: <PinVerification />,
  },
];
